import { TagColor } from './types';

// 标记相关配置
export const tagColors: TagColor[] = [
  { bg: 'bg-blue-100', text: 'text-blue-800', hover: 'text-blue-600' },
  { bg: 'bg-green-100', text: 'text-green-800', hover: 'text-green-600' },
  { bg: 'bg-purple-100', text: 'text-purple-800', hover: 'text-purple-600' },
  { bg: 'bg-yellow-100', text: 'text-yellow-800', hover: 'text-yellow-600' },
  { bg: 'bg-pink-100', text: 'text-pink-800', hover: 'text-pink-600' }
];

// 随机获取标记颜色
export function getRandomTagColor(): TagColor {
  return tagColors[Math.floor(Math.random() * tagColors.length)];
}

// 数据本地存储相关
export const STORAGE_KEY = 'priceRecords';

// 获取本地存储数据
export function getLocalStorageData() {
  return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
}

// 保存数据到本地存储
export function saveToLocalStorage(data: any[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

// 日期格式化函数
export function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// 获取今天的日期
export function getTodayDate(): string {
  return formatDate(new Date());
}

// 本地存储键名
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER_INFO: 'user_info'
};

// 保存认证信息到本地存储
export const saveAuthToStorage = (token: string, user: any) => {
  localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, token);
  localStorage.setItem(STORAGE_KEYS.USER_INFO, JSON.stringify(user));
};

// 从本地存储获取认证信息
export const getAuthFromStorage = () => {
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  const userJson = localStorage.getItem(STORAGE_KEYS.USER_INFO);
  const user = userJson ? JSON.parse(userJson) : null;
  
  return {
    token,
    user,
    isAuthenticated: !!token && !!user
  };
};

// 清除本地存储中的认证信息
export const clearAuthFromStorage = () => {
  localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN);
  localStorage.removeItem(STORAGE_KEYS.USER_INFO);
}; 